import cx from "classnames";

export type ContainerProps = {
  rootClassName?: string;
  children?: React.ReactElement | React.ReactElement[];
};

export default function Container(props: ContainerProps): React.ReactElement {
  const { rootClassName, children, ...rest } = props;

  return (
    <div
      data-component="component-container"
      className={cx(rootClassName, "container px-3")}
      {...rest}
    >
      {children}
    </div>
  );
}
